import { ModuleWithProviders, NgModule } from '@angular/core';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
import { DfHeaderUi } from './df-header-ui.interfaces';
import { DfHeaderUiHeaderDirective } from './directive/df-header-ui-header.directive';

@NgModule({
    imports: [DfHeaderUiHeaderDirective],
    exports: [DfHeaderUiHeaderDirective]
})
export class DfHeaderUiModule {
    static forRoot(config: DfHeaderUi.IModuleOptions): ModuleWithProviders<DfHeaderUiModule> {
        ICmsContentService.registerComponentMetaPatch(meta => {
            if (meta.id === config.headerComponentId) {
                meta.fields.push(DfHeaderUi.Field.Block.Title);
                if (config.fields.transparency) {
                    meta.fields.push(DfHeaderUi.Field.Block.Transparency);
                }
                if (config.fields.theme) {
                    meta.fields.push(<NICmsContentField.IChoiceField>{ ...DfHeaderUi.Field.Block.Theme, options: getThemeOptions() });
                }
                // if (config.fields.hiding) {
                //     meta.fields.push(DfHeaderUi.Field.Hiding);
                // }
            }
        });

        ICmsContentService.registerPageMetaPatch(meta => {
            if (config.fields.transparency) {
                if (!meta.fields) {
                    meta.fields = [];
                } 
                meta.fields.push(DfHeaderUi.Field.Page.Transparency);
            }
            // if (config.fields.hiding) {
            //     meta.fields.push(DfHeaderUi.Field.Hiding);
            // }
            if (config.fields.theme) {
                if (!meta.fields) {
                    meta.fields = [];
                }
                meta.fields.push(<NICmsContentField.IChoiceField>{ ...DfHeaderUi.Field.Page.Theme, options: getThemeOptions() });
            }
        });

        return {
            ngModule: DfHeaderUiModule,
            providers: [
                {
                    provide: DfHeaderUi.OPTIONS,
                    useFactory: () => {
                        return defaultsDeep(config, <DfHeaderUi.IModuleOptions>{});
                    }
                }
            ]
        };

        function getThemeOptions(): NICmsContentField.IOption<string>[] {
            const keys = Object.keys(config.fields.theme.options);
            return [{ key: '', title: 'Default' }, ...keys.map(key => ({ key, title: config.fields.theme.options[key] }))];
        }
    }
}
